module.exports = __webpack_public_path__ + "img/aliff.4a68cc6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/study-abroad/img/aliff.svg
// module id = 2007
// module chunks = 1